import { IconProps, IconNames } from './Icon.types';
import { svgList } from './icons';
const getIconByName = (name: IconNames) => svgList[name];

export const UnstyledIcon = ({ name, ...props }: IconProps) => {
  const IconElement = getIconByName(name);

  return <IconElement {...props} />;
};
